import { createContext, ReactNode, useContext } from 'react';
import { BookOrderActionProps, useBookOrderAction } from './book-order-action.hook';

// This context is only exported for use in Storybook for injecting mock context values
export const BookOrderActionContext = createContext<ReturnType<typeof useBookOrderAction>>(undefined!);

// This context provider is used to wrap the book order modal in the real context values
export function BookOrderActionContextProvider({ children, ...rest }: { children: ReactNode } & BookOrderActionProps) {
  const context = useBookOrderAction(rest);
  return <BookOrderActionContext.Provider value={context}>{children}</BookOrderActionContext.Provider>;
}

export function useBookOrderActionContext() {
  return useContext(BookOrderActionContext);
}
